import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import DatePicker from "react-datepicker";
import { useNavigate } from 'react-router-dom'
import { country_code_array2 } from '../functions';
import "react-datepicker/dist/react-datepicker.css";
import BACKEND_URL from '../../../api';

import '../../../My_Account.css'
import Sidebar from './Sidebar';
import { Helmet } from 'react-helmet';

export default function Multiple_Document_quote() {

    const [isOpen, setIsOpen] = useState(false);
    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };
    const navigate = useNavigate()
    const [countdiv, setcountdiv] = useState(1)
    function increment() {
        setcountdiv((prevCount) => prevCount + 1);
        const updatedData = [...getQuotedata]; // Create a shallow copy of the existing data

        if (exportclass[0] == "active") {
            updatedData.push({ // Use push to add a new item to the copied array
                user: user,
                origin: 'AE',
                destination: 'GB',
                shipmenttype: "exportdiv",
                typediv: "document",
                shipping_date: startDate,
                dimensions: {
                    weight: ['0.5'],
                    length: ['0'],
                    width: ['0'],
                    height: ['0']

                }
            });
            setgetQuotedata(updatedData);

            const updatedExportList = [...exportclass]; // Create a shallow copy of the existing data
            updatedExportList.push('active');
            setexportclass(updatedExportList);

            const updatedImportList = [...importclass]; // Create a shallow copy of the existing data
            updatedImportList.push('');
            setimportclass(updatedImportList);
        } else {
            updatedData.push({ // Use push to add a new item to the copied array
                user: user,
                origin: 'GB',
                destination: 'AE',
                shipmenttype: "importdiv",
                typediv: "document",
                shipping_date: startDate,
                dimensions: {
                    weight: ['0.5'],
                    length: ['0'],
                    width: ['0'],
                    height: ['0']

                }
            });
            setgetQuotedata(updatedData);

            const updatedExportList = [...exportclass]; // Create a shallow copy of the existing data
            updatedExportList.push('');
            setexportclass(updatedExportList);

            const updatedImportList = [...importclass]; // Create a shallow copy of the existing data
            updatedImportList.push('active');
            setimportclass(updatedImportList);
        }
    }
    const [countries, setcountries] = useState(country_code_array2);
    const date = new Date();
    const today = date.getDay()

    const [startDate, setStartDate] = useState(today == 6 ? new Date(date.setDate(date.getDate() + 2)) : new Date(date.setDate(date.getDate() + 1)))

    const date2 = new Date();
    const today2 = date2.getDay()
    const [startDate2, setStartDate2] = useState(today2 == 6 ? new Date(date2.setDate(date2.getDate() + 2)) : new Date(date2.setDate(date2.getDate() + 1)))

    const isWeekday = (date) => {
        const day = date.getDay();
        return day !== 0;
    };

    const [exportclass, setexportclass] = useState(['active'])
    const [importclass, setimportclass] = useState([''])

    function showthisdiv(val, i) {
        if (val == 'exportdiv') {
            const updateData = getQuotedata.map((item, index) => {
                if (index === i) {
                    return {
                        ...item,
                        shipmenttype: val,
                        origin: 'AE',
                        destination: 'GB'
                    };
                }
                return item;
            });
            setgetQuotedata(updateData);

            const updatedExportList = exportclass.map((item, index) => {
                if (index == i) {
                    return 'active'
                } else {
                    return item;
                }
            });
            setexportclass(updatedExportList);

            const updatedImportList = importclass.map((item, index) => {
                if (index == i) {
                    return ''
                } else {
                    return item;
                }
            });
            setimportclass(updatedImportList);
        } else if (val == 'importdiv') {
            const updateData = getQuotedata.map((item, index) => {
                if (index === i) {
                    return {
                        ...item,
                        shipmenttype: val,
                        origin: 'GB',
                        destination: 'AE'
                    };
                }
                return item;
            });
            setgetQuotedata(updateData);

            const updatedExportList = exportclass.map((item, index) => {
                if (index == i) {
                    return ''
                } else {
                    return item;
                }
            });
            setexportclass(updatedExportList);

            const updatedImportList = importclass.map((item, index) => {
                if (index == i) {
                    return 'active'
                } else {
                    return item;
                }
            });
            setimportclass(updatedImportList);
        }
    }

    const user = sessionStorage.getItem('userid');
    const [getQuotedata, setgetQuotedata] = useState([
        {
            user: user,
            origin: 'AE',
            destination: 'GB',
            shipmenttype: "exportdiv",
            typediv: "document",
            shipping_date: startDate,
            dimensions: {
                weight: ['0.5'],
                length: ['0'],
                width: ['0'],
                height: ['0']

            }
        }
    ])

    function updateweight(val, i) {
        const updatedData = [...getQuotedata]; // Create a shallow copy of the array
        updatedData[i] = {
            ...updatedData[i], // Copy existing properties of the object at index i
            dimensions: {
                ...updatedData[i].dimensions, // Copy existing dimensions
                weight: [
                    val, // Update the first element with val
                    ...updatedData[i].dimensions.weight.slice(1) // Keep the rest of the existing lengths
                ]
            }
        };
        setgetQuotedata(updatedData);
    }

    function updatelength(val, i) {
        const updatedData = [...getQuotedata]; // Create a shallow copy of the array
        updatedData[i] = {
            ...updatedData[i], // Copy existing properties of the object at index i
            dimensions: {
                ...updatedData[i].dimensions, // Copy existing dimensions
                length: [
                    val, // Update the first element with val
                    ...updatedData[i].dimensions.length.slice(1) // Keep the rest of the existing lengths
                ]
            }
        };
        setgetQuotedata(updatedData);
    }

    function updatewidth(val, i) {
        const updatedData = [...getQuotedata]; // Create a shallow copy of the array
        updatedData[i] = {
            ...updatedData[i], // Copy existing properties of the object at index i
            dimensions: {
                ...updatedData[i].dimensions, // Copy existing dimensions
                width: [
                    val, // Update the first element with val
                    ...updatedData[i].dimensions.width.slice(1) // Keep the rest of the existing lengths
                ]
            }
        };
        setgetQuotedata(updatedData);
    }

    function updateheight(val, i,) {
        const updatedData = [...getQuotedata]; // Create a shallow copy of the array
        updatedData[i] = {
            ...updatedData[i], // Copy existing properties of the object at index i
            dimensions: {
                ...updatedData[i].dimensions, // Copy existing dimensions
                height: [
                    val, // Update the first element with val
                    ...updatedData[i].dimensions.height.slice(1) // Keep the rest of the existing lengths
                ]
            }
        };
        setgetQuotedata(updatedData);
    }

    function changedate(date) {
        setStartDate(date)
        const updatedData = getQuotedata.map((item) => ({
            ...item, // Spread the existing properties of the item
            shipping_date: date // Update the shipping_date property
        }));
        setgetQuotedata(updatedData);
    }

    async function getQuote() {
        const jsonArray = [];
        const fetchPromises = getQuotedata.map(async (item, index) => {
            try {
                const response = await fetch(`${BACKEND_URL}/quote`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        user: item.user,
                        origin: item.origin,
                        destination: item.destination,
                        shipmenttype: item.shipmenttype,
                        typediv: item.typediv,
                        shipping_date: item.shipping_date,
                        dimensions: item.dimensions,
                    }),
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                jsonArray.push({
                    index: index,
                    basic: data.basic,
                    qoute_rate: data.rate,
                    get_gov_vat: data.charge1,
                    charge_rate: data.charge_rate,
                    es_surcharge: data.es_surcharge,
                    oversize: data.oversize,
                    er_charge: data.er_charge,
                    rd_charge: data.RD_charge,
                    user_discount: data.user_discount,
                    user_text: data.user_text,
                    weight: data.weight,
                    chargable_weight: data.chargable_weight,
                    get_transit_time: data.get_transit_time,
                    demand_surcharge: data.demand_surcharge,
                });
            } catch (error) {
                console.error(error.message);
            }
        });
        // Wait for all fetch promises to resolve
        await Promise.all(fetchPromises);
        jsonArray.sort((a, b) => a.index - b.index);
        sessionStorage.setItem('qouteinput[]', JSON.stringify(getQuotedata));
        navigate('/quotationList', {
            state: jsonArray
        });
        // fetch(`${BACKEND_URL}/quote`, {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify(getQuotedata)
        // })
        //     .then((res) => {
        //         if (!res.ok) {
        //             throw new Error('Network response was not ok');
        //         }
        //         return res.json(); // Assuming the response is in JSON format
        //     })
        //     .then((data) => {
        //         // Store the quoted data in session storage
        //         sessionStorage.setItem('qouteinput', JSON.stringify(getQuotedata));
        //         // Navigate to the quotation page with the response data
        //         navigate('/quotation', {
        //             state: {
        //                 basic: data.basic,
        //                 qoute_rate: data.rate,
        //                 get_gov_vat: data.charge1,
        //                 charge_rate: data.charge_rate,
        //                 es_surcharge: data.es_surcharge,
        //                 oversize: data.oversize,
        //                 er_charge: data.er_charge,
        //                 rd_charge: data.RD_charge,
        //                 user_discount: data.user_discount,
        //                 user_text: data.user_text,
        //                 weight: data.weight,
        //                 chargable_weight: data.chargable_weight,
        //                 get_transit_time: data.get_transit_time,
        //                 demand_surcharge: data.demand_surcharge
        //             }
        //         });
        //     })
        //     .catch(error => console.log(error.message));
    }

    function removemore(val, shiptype) {
        if (shiptype == 'inter') {
            setcountdiv((prevCount) => prevCount - 1); // Decrease the shipment count
            const updatedData = getQuotedata.filter((_, index) => index !== val); // Create a new array excluding the item at index i
            setcountdiv(updatedData);

            let updateData1 = exportclass.filter((_, index) => index !== val); // Create a new array excluding the item at index i
            setexportclass(updateData1);
            updateData1 = importclass.filter((_, index) => index !== val); // Create a new array excluding the item at index i
            setimportclass(updateData1);
        }
    }

    return (
        <div className="my_parcels">
            <Helmet>
                <title>Shypv | Document Quote</title>
            </Helmet>
            <div className="myparctab" style={{ padding: "0" }}>

                <div className="container-fluid" style={{ padding: "0" }}>
                    <div className="row1">

                        <Sidebar isOpen={isOpen} />
                        <div id="admin-main-control" className="col-md-9 p-x-3 p-y-1" style={{ overflow: "auto", backgroundColor: "#f1f5f9" }}>
                            <div style={{ boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)" }}>
                                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                                    <div className="container-fluid" style={{ justifyContent: "space-between" }}>
                                        <button className="navbar-toggler" type="button" onClick={toggleSidebar}>
                                            {
                                                isOpen ? (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="32"
                                                        height="32"
                                                        className="bi bi-arrow-bar-left"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"
                                                        />
                                                    </svg>
                                                ) : (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="32"
                                                        height="32"
                                                        className="bi bi-arrow-bar-right"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5"
                                                        />
                                                    </svg>
                                                )
                                            }
                                        </button>
                                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="offset-1 collapse navbar-collapse" id="navbarNav">
                                            <ul className="navbar-nav">
                                                <>
                                                    <li className="nav-item">
                                                        <NavLink activeclassname="active" exact to="/">HOME</NavLink>
                                                        {/* <Link className="nav-link active"  aria-current="page" exact  to="/">HOME  </Link> */}
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink exact to="/track">TRACK</NavLink>
                                                        {/* <Link className="nav-link" exact  to="/track">TRACK</Link> */}
                                                    </li>

                                                    {/* <li className="nav-item">
                                                            <NavLink exact to="/smart-send">SMART SEND</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/your-business">YOUR BUSINESS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/help">HELP</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/become-a-partner">PARTNERS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/parcels-on-demand">HOW IT WORKS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="https://www.tymexlogistics.com/" target="_blank">LOGISTICS</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/client-zone">CLIENT ZONE</NavLink>
                                                        </li> */}
                                                </>
                                            </ul>
                                        </div>
                                    </div>
                                </nav>
                            </div>

                            <div style={{ margin: "20px", padding: "20px", backgroundColor: "white", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)" }}>
                                <form method="post" action="<?php echo get_the_permalink(193); ?>" id="send_parcels">
                                    <h3 className="comaprison_hedding">QUOTE DOCUMENT</h3>
                                    {[...Array(countdiv)].map((e, i) =>
                                        <>
                                            <div className="col-md-12 col-sm-12 yodeldirect" id="quote_get" key={i}>
                                                <div className="row">
                                                    <div className="col-md-12 col-sm-12 send_a_parcel">
                                                        <div id="exTab1" style={{ border: " 1px solid #3c50e1" }}>
                                                            <div>
                                                                <ul className="nav nav-pills">
                                                                    <li className={`${getQuotedata[i].shipmenttype == "exportdiv" && "active"}`}><a onClick={() => showthisdiv('exportdiv', i)} className="import_export" flag="export" id="export-link">Export</a></li>
                                                                    <li className={`${getQuotedata[i].shipmenttype == "importdiv" && "active"}`}><a onClick={() => showthisdiv('importdiv', i)} className="import_export" flag="import" id="import-link">Import</a></li>
                                                                </ul>
                                                                {i > 0 ? (
                                                                    <button type="button" style={{ float: "right", marginTop: "10px", marginRight: "10px" }} className="removebtn" onClick={() => removemore(i, 'inter')}>x</button>
                                                                ) : null}
                                                            </div>

                                                            {getQuotedata[i].shipmenttype && getQuotedata[i].shipmenttype == 'exportdiv' ? (
                                                                <div className="tab-content clearfix quotetab">
                                                                    <div className="tab-pane " id="1a" style={{ background: "#fff !important", display: "block" }}>
                                                                        <h3 className="section-head" style={{ fontSize: "16px", color: "#3c50e0", fontWeight: "500", marginTop: "2%" }}>Where are you sending your parcels from/to?</h3>
                                                                        <div className="tab-content">
                                                                            <div id="export" className="export-content">
                                                                                <ul className="business_region quotesec2 export-area">
                                                                                    <li>
                                                                                        <label style={{ color: "#000 !important" }}>From</label>
                                                                                        <select
                                                                                            id="export_from"
                                                                                            className="form-control export-field from_country delivery_from"
                                                                                            name="delivery_from"
                                                                                            onChange={(e) => {
                                                                                                const updatedData = [...getQuotedata]; // Create a shallow copy of the array
                                                                                                updatedData.map((item, index) => {
                                                                                                    if (index == i) {
                                                                                                        item.origin = e.target.value;
                                                                                                        return item;
                                                                                                    } else return item;
                                                                                                });
                                                                                                setgetQuotedata(updatedData); // Update the state with the new array
                                                                                            }}
                                                                                        >
                                                                                            <option value="AE">Abu Dhabi</option>
                                                                                            <option value="AE">Ajman</option>
                                                                                            <option value="AE">Al Ain</option>
                                                                                            <option value="AE" selected>Dubai</option>
                                                                                            <option value="AE">Fujairah</option>
                                                                                            <option value="AE">Ras Al Khaimah</option>
                                                                                            <option value="AE">Sharjah</option>
                                                                                            <option value="AE">Umm Al Quwain</option>
                                                                                        </select>
                                                                                    </li>
                                                                                    <li>
                                                                                        <label >To</label>
                                                                                        <select
                                                                                            id="export_to"
                                                                                            className="form-control export-field import-field-to to_country delivery_to"
                                                                                            name="delivery_to"
                                                                                            onChange={(e) => {
                                                                                                const updatedData = [...getQuotedata]; // Create a shallow copy of the array
                                                                                                updatedData[i] = { ...updatedData[i], destination: e.target.value }; // Update the specific object's origin
                                                                                                setgetQuotedata(updatedData); // Update the state with the new array
                                                                                            }}
                                                                                        >
                                                                                            {
                                                                                                Object.entries(countries).map(([k, v]) => (
                                                                                                    <option key={k} value={k} selected={k === 'GB'}>{v}</option>
                                                                                                ))
                                                                                            }
                                                                                        </select>
                                                                                        <input type="hidden" name="ip_country" defaultValue className="ip_country" />
                                                                                    </li>
                                                                                    <p className="error" />
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ) : null}

                                                            {getQuotedata[i].shipmenttype && getQuotedata[i].shipmenttype == 'importdiv' ? (
                                                                <div className="tab-content clearfix quotetab">
                                                                    <div className="tab-pane1" id="2a">
                                                                        <h3 className="section-head" style={{ fontSize: "16px", color: "#3c50e0", fontWeight: "500", marginTop: "2%" }}>Where are you sending your parcels from/to?</h3>
                                                                        <div className="tab-content">
                                                                            <ul className="business_region quotesec2 export-area">
                                                                                <li>
                                                                                    <label>From</label>
                                                                                    <select
                                                                                        id="import_from"
                                                                                        className="form-control import-field import-field-from to_country delivery_from"
                                                                                        name="delivery_from"
                                                                                        onChange={(e) => {
                                                                                            const updatedData = [...getQuotedata]; // Create a shallow copy of the array
                                                                                            updatedData.map((item, index) => {
                                                                                                if (i == index) {
                                                                                                    item.origin = e.target.value;
                                                                                                    return item;
                                                                                                } else return item;
                                                                                            });
                                                                                            setgetQuotedata(updatedData); // Update the state with the new array
                                                                                        }}
                                                                                    >
                                                                                        {
                                                                                            Object.entries(countries).map(([k, v]) => (
                                                                                                <option key={k} value={k} selected={k === 'GB'}>{v}</option>
                                                                                            ))
                                                                                        }
                                                                                    </select>
                                                                                </li>
                                                                                <li>
                                                                                    <label>To</label>
                                                                                    <select
                                                                                        id="import_to"
                                                                                        className="form-control import-field from_country delivery_to"
                                                                                        name="delivery_to"
                                                                                        onChange={(e) => {
                                                                                            const updatedData = [...getQuotedata]; // Create a shallow copy of the array
                                                                                            updatedData[i] = { ...updatedData[i], destination: e.target.value }; // Update the specific object's origin
                                                                                            setgetQuotedata(updatedData); // Update the state with the new array
                                                                                        }}
                                                                                    >
                                                                                        <option value="AE">Abu Dhabi</option>
                                                                                        <option value="AE">Ajman</option>
                                                                                        <option value="AE">Al Ain</option>
                                                                                        <option value="AE" selected>Dubai</option>
                                                                                        <option value="AE">Fujairah</option>
                                                                                        <option value="AE">Ras Al Khaimah</option>
                                                                                        <option value="AE">Sharjah</option>
                                                                                        <option value="AE">Umm Al Quwain</option>
                                                                                    </select>
                                                                                    <input type="hidden" name="ip_country" defaultValue className="ip_country" />
                                                                                </li>
                                                                                <p className="error" />
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ) : null
                                                            }

                                                            <div className="tab-content clearfix quotetab">
                                                                <div className="tab-pane1" id="2a">
                                                                    <div className="add_more_weight">
                                                                        <div>
                                                                            <h3 className="section-head" style={{ fontSize: "16px", color: "#3c50e0", fontWeight: "500", marginTop: "2%" }}>Enter the weight and dimensions of your parcels </h3>
                                                                            <ul className="business_region">

                                                                                <li style={{ width: "24%" }}>
                                                                                    <label className="label--reg">Weight<span className="required">*</span> (kg)</label>
                                                                                    <select className="form-control weight-class weight-class-first" name="weight[]" onChange={(e) => updateweight(e.target.value, i)}>
                                                                                        {i > 0 ? (
                                                                                            <option value="">select weight</option>
                                                                                        ) : null
                                                                                        }
                                                                                        <option value="0.5" selected={getQuotedata[i].dimensions.weight[0] === '0.5'}>0.5</option>
                                                                                        <option value="1" selected={getQuotedata[i].dimensions.weight[0] === '1'}>1</option>
                                                                                        <option value="1.5" selected={getQuotedata[i].dimensions.weight[0] === '1.5'}>1.5</option>
                                                                                        <option value="2" selected={getQuotedata[i].dimensions.weight[0] === '2'}>2</option>
                                                                                    </select>
                                                                                </li>
                                                                                <li style={{ width: "24%", marginRight: "1%" }}>
                                                                                    <label className="label--reg">Length (cm)</label>
                                                                                    <input className="input--small form-control weight-class weight-class-first" name="length[]" value={getQuotedata[i].dimensions.length[0]} placeholder type="number" min={0} onChange={(e) => updatelength(e.target.value, i)}
                                                                                        onKeyPress={(e) => {
                                                                                            const charCode = e.which ? e.which : e.keyCode;
                                                                                            // Allow only numbers (0-9) and control keys (like backspace)
                                                                                            if ((charCode < 48 || charCode > 57)) {
                                                                                                e.preventDefault();
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </li>
                                                                                <li style={{ width: "24%", marginRight: "1%" }}>
                                                                                    <label className="label--reg">Width (cm)</label>
                                                                                    <input className="input--small form-control weight-class weight-class-first required" value={getQuotedata[i].dimensions.width[0]} name="width[]" placeholder type="number" min={0} onChange={(e) => updatewidth(e.target.value, i)}
                                                                                        onKeyPress={(e) => {
                                                                                            const charCode = e.which ? e.which : e.keyCode;
                                                                                            // Allow only numbers (0-9) and control keys (like backspace)
                                                                                            if ((charCode < 48 || charCode > 57)) {
                                                                                                e.preventDefault();
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </li>
                                                                                <li style={{ width: "24%", marginRight: "1%" }}>
                                                                                    <label className="label--reg">Height (cm)</label>
                                                                                    <input className="input--small form-control weight-class weight-class-first" value={getQuotedata[i].dimensions.height[0]} name="height[]" placeholder type="number" min={0} onChange={(e) => updateheight(e.target.value, i)}
                                                                                        onKeyPress={(e) => {
                                                                                            const charCode = e.which ? e.which : e.keyCode;
                                                                                            // Allow only numbers (0-9) and control keys (like backspace)
                                                                                            if ((charCode < 48 || charCode > 57)) {
                                                                                                e.preventDefault();
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>

                                                                    {
                                                                        countdiv == i + 1 && (
                                                                            <div className="cross_Another_sec" style={{ marginBottom: "10px" }}>+
                                                                                <button className="btn btn-parcels noradius" id="add_more_sizes" type="button" onClick={increment} style={{ color: "#2c4079", borderBottom: "1px solid" }}>
                                                                                    <div className="center-con cross_icons">
                                                                                        <div className="round">
                                                                                            <span />
                                                                                            <span />
                                                                                            <span />
                                                                                            <span />
                                                                                        </div>
                                                                                    </div>
                                                                                    Add a different shipment
                                                                                </button>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className="hr_border" />
                                            </div >
                                        </>
                                    )}
                                    <div className="col-md-10 col-sm-10 parcel_date quotetab">
                                        <h3 className="section-head" style={{ fontSize: "16px", color: "#3c50e0", fontWeight: "500", marginTop: "2%" }}>When are you shipping?</h3>
                                        <DatePicker className="form-control shipping_date" filterDate={isWeekday} minDate={startDate2} name="shipping_date" dateFormat='dd/MM/yyyy' selected={startDate}
                                            onChange={date => {
                                                changedate(date);
                                            }} />
                                    </div>
                                    <hr className="hr_border" />
                                    <div className="wrape_promo">

                                        <span className="get_center_bnts">
                                            <label className>&nbsp;</label>
                                            <button className="btn_same1" type="button" name="get_quotes" id="get_quote" onClick={getQuote}>SUBMIT</button>
                                            <input type="hidden" name="get_quote" defaultValue="Get Quote" />

                                            <input type="hidden" name="parcel_type" id="parcel_type" defaultValue="export" />
                                            <input type="hidden" name="promo_discount" defaultValue id="promo_discount" />
                                        </span>
                                    </div>
                                </form>
                            </div>
                        </div>


                    </div> {/* /.row */}
                </div> {/* /.container-fluid */}
            </div>
        </div >
    )
}


